import styled from 'styled-components';

export const Wrapper = styled.div<{ width?: string }>`
  width: 100%;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  .react-tiny-popover-container {
    /* width: 820px !important; */
    position: relative;
  }
`;
export const ResponsivePopUp = styled.div<{ padding?: boolean }>`
  padding-left: ${({ padding }) => (padding ? '10px' : '0px')};
  padding-right: ${({ padding }) => (padding ? '10px' : '0px')};
`;
